/**
 * Canonical machine type IDs and labels
 */

/** @enum {number} Integer stored on vehicle documents as machineType */
const MachineType = Object.freeze({
  NOT_ASSIGNED: 0,
  ROAD_VEHICLE: 1,
  TRACTOR: 2,
  TRAILER: 3,
  ATV: 4,
  PLATFORM: 5,
  CONSTRUCTION: 6,
  OTHER: 7,
  STATIONARY: 8,
});

const machineTypeMapping = {
  0: 'Not Assigned',
  1: 'Road Vehicle',
  2: 'Tractor',
  3: 'Trailer',
  4: 'ATV',
  5: 'Platform',
  6: 'Construction',
  7: 'Other',
  8: 'Stationary',
};

/** @type {Record<number, string>} URL paths under site root */
const machineIconMapping = {
  0: '/img/tractor_green.png',
  1: '/img/passenger-vehicle.png',
  2: '/img/tractor_green.png',
  3: '/img/trailer.png',
  4: '/img/atv.png',
  5: '/img/platform.png',
  6: '/img/construction.png',
  7: '/img/other.png',
  8: '/img/stationary.png',
};

/**
 * Preloads images for deck.gl icon outline rendering (browser only).
 * @return {Record<number, HTMLImageElement>}
 */
function createMachineIconImageMapping() {
  const out = {};
  for (const idStr of Object.keys(machineIconMapping)) {
    const id = parseInt(idStr, 10);
    const img = new Image();
    img.src = machineIconMapping[id];
    out[id] = img;
  }
  return out;
}

module.exports = {
  MachineType,
  machineTypeMapping,
  machineIconMapping,
  createMachineIconImageMapping,
};
